define('v3/Pages/Settings/Services/Lvs.Service',[
	'v3/Pages/Settings/Services/Lvs.Backend'
], function (
	lvsBackend
) {
	return {
		getLvsSyncStatus: function (schoolId) {
			return lvsBackend.getLvsSyncStatus(schoolId);
		}
	};
});

